(() => {
 const DEBUG_THUMB_VARIANT = false;

  const normSrc = (src) => {
    if (!src) return "";
    try {
      const u = new URL(src, window.location.origin);
      // Remove Shopify size params like &width=130 by ignoring search entirely
      return u.origin + u.pathname;
    } catch {
      // Fallback if URL() fails
      return String(src).split("?")[0].split("&")[0];
    }
  };

  const cssEscape = (val) => {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(val);
    return String(val).replace(/["\\]/g, "\\$&");
  };

  const toNumericId = (maybeId) => {
    if (!maybeId) return null;
    const m = String(maybeId).match(/(\d{6,})/);
    return m ? m[1] : null;
  };

  /* ===============================
     Product JSON Resolver (Warehouse)
  ================================ */

  const findProductJson = () => {
    // PRIMARY: Warehouse exposes:
    // <script type="application/json" id="ProductJson-{{ section.id }}">
    const el = document.querySelector('script[id^="ProductJson-"]');

    if (el && el.textContent) {
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn("[thumb-variant] ProductJson parse failed", e);
      }
    }

    // FALLBACK: Shopify analytics meta
    const meta = window.Shopify?.Analytics?.meta?.product;
    if (meta?.variants && Array.isArray(meta.variants)) {
      return {
        variants: meta.variants.map((v) => ({
          id: v.id,
          options: v.options,
          featured_image: v.featured_image || null,
          featured_media: v.featured_media || null,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
        })),
      };
    }

    console.warn("[thumb-variant] No product JSON found on page");
    return null;
  };

  const buildMaps = (productJson) => {
    const byMediaId = new Map();
    const bySrc = new Map();

    for (const v of productJson.variants) {
      const mediaId =
        (v.featured_media && v.featured_media.id) ||
        v.featured_media_id ||
        (v.featured_image && (v.featured_image.id || v.featured_image.media_id)) ||
        v.featured_image_id ||
        null;

      const src =
        (v.featured_image && (v.featured_image.src || v.featured_image.url)) ||
        (v.featured_media && (v.featured_media.preview_image?.src || v.featured_media.preview_image?.url)) ||
        null;

      const nMediaId = toNumericId(mediaId);
      if (nMediaId) byMediaId.set(nMediaId, v);

      const nSrc = normSrc(src);
      if (nSrc) bySrc.set(nSrc, v);
    }

    return { byMediaId, bySrc };
  };

  const findThumbMediaId = (el) => {
    // Prefer the thumbnail anchor itself (Warehouse commonly uses:
    // <a class="product-gallery__thumbnail" data-media-id="...">)
    const thumb =
      el?.closest?.(".product-gallery__thumbnail") ||
      el?.closest?.("[data-media-id]") ||
      el?.closest?.("[data-image-id]") ||
      el?.closest?.("[data-gallery-media-id]") ||
      el?.closest?.("[data-gallery-image-id]") ||
      el;

    if (!thumb) return null;

    const raw =
      thumb.getAttribute("data-media-id") ||
      thumb.getAttribute("data-gallery-media-id") ||
      thumb.getAttribute("data-image-id") ||
      thumb.getAttribute("data-gallery-image-id") ||
      null;

    return toNumericId(raw);
  };

  // Keep this if you want it later; not currently used by boot()
  const clickOptionControls = (variant) => {
    if (!variant?.options?.length) return false;

    for (let i = 0; i < variant.options.length; i++) {
      const val = variant.options[i];
      const pos = i + 1;

      // Prefer radio inputs (most Warehouse pills are radios styled as buttons)
      const radio =
        document.querySelector(
          `input[type="radio"][data-option-position="${pos}"][value="${cssEscape(val)}"]`
        ) ||
        document.querySelector(
          `input[type="radio"][name="options[${i}]"][value="${cssEscape(val)}"]`
        ) ||
        document.querySelector(`input[type="radio"][value="${cssEscape(val)}"]`);

      if (radio) {
        radio.click();
        continue;
      }

      // Fallback: selects
      const select =
        document.querySelector(`select[data-option-position="${pos}"]`) ||
        document.querySelector(`select[name="options[${i}]"]`);

      if (select) {
        if (select.value !== val) {
          select.value = val;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
        continue;
      }

      // Fallback: button elements with data-value
      const btn =
        document.querySelector(`[data-option-position="${pos}"][data-value="${cssEscape(val)}"]`) ||
        document.querySelector(`[data-value="${cssEscape(val)}"]`);

      if (btn?.click) {
        btn.click();
        continue;
      }

      // If we can't find a control for one option, stop
      return false;
    }

    return true;
  };

  const applyVariantOptionsToUI = (variant) => {
    const desired = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    let applied = 0;

    desired.forEach((value) => {
      let matched = false;

      // 1) Buttons / pills
      document.querySelectorAll("button, a").forEach((el) => {
        if (matched) return;

        const text = el.textContent?.trim();
        const ariaDisabled = el.getAttribute?.("aria-disabled") === "true";
        const isDisabled = typeof el.disabled === "boolean" ? el.disabled : ariaDisabled;

        if (text === value && !isDisabled) {
          el.click();
          matched = true;
          applied++;
        }
      });

      // 2) Radios
      if (!matched) {
        document.querySelectorAll('input[type="radio"]').forEach((radio) => {
          if (matched) return;
          const label = radio.id ? document.querySelector(`label[for="${radio.id}"]`) : null;
          if (label?.textContent?.trim() === value && !radio.disabled) {
            radio.click();
            matched = true;
            applied++;
          }
        });
      }

      // 3) Selects
      if (!matched) {
        document.querySelectorAll("select").forEach((select) => {
          if (matched) return;
          [...select.options].forEach((opt) => {
            if (matched) return;
            if (opt.text.trim() === value) {
              select.value = opt.value;
              select.dispatchEvent(new Event("change", { bubbles: true }));
              matched = true;
              applied++;
            }
          });
        });
      }
    });

    return {
      desiredCount: desired.length,
      applied,
    };
  };

  /* === expose for debugging (AFTER definitions) === */
 if (DEBUG_THUMB_VARIANT) {
  window.__xmxFindProductJson = findProductJson;
  window.__xmxApplyVariantOptionsToUI = applyVariantOptionsToUI;
}


  /* === boot === */
  const boot = () => {
    const productJson = findProductJson();
    if (!productJson) {
      console.warn("[thumb→variant] No product JSON found on page.");
      return;
    }

    const { byMediaId, bySrc } = buildMaps(productJson);

    // Delegate click from thumbnail area
    document.addEventListener(
      "click",
      (e) => {
        const t = e.target;
        if (!t) return;

        // Limit to clicks in/near thumbnails
        const img = t.closest("img");
        if (!img) return;

        // Try media-id mapping first
        const mediaId = findThumbMediaId(img);
        let variant = mediaId ? byMediaId.get(mediaId) : null;

        // Fallback to src mapping
        if (!variant) {
          variant = bySrc.get(normSrc(img.currentSrc || img.src)) || null;
        }

        if (!variant) {
          console.warn("[thumb→variant] No variant matched for thumbnail", {
            mediaId,
            src: normSrc(img.currentSrc || img.src),
          });
          return;
        }

        const result = applyVariantOptionsToUI(variant);

        if (result.applied !== result.desiredCount) {
          console.warn("[thumb-variant] Matched variant but UI apply incomplete", {
            variantId: variant.id,
            desired: [variant.option1, variant.option2, variant.option3],
            result,
          });
        } else {
          
        }
      },
      true
    );
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
